import ReportEditBrandAttributeMap from './reportEditBrandAttributeMap'
export default ReportEditBrandAttributeMap
